import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AutoRegionBanner from "@/components/AutoRegionBanner";
import AutoDiscountWelcome from "@/components/AutoDiscountWelcome";
import Europe from "@/pages/Europe";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import BlogIndex, { BlogPost } from "@/pages/Blog";
import TorwarthandschuheDamen from "@/pages/TorwarthandschuheDamen";
import AdLandingPage from "@/pages/AdLandingPage";

const AD_LANDING_KEYS = new Set(["panther-pro", "mamba-pro"]);

const Shell = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isAdLanding = AD_LANDING_KEYS.has(location.pathname.replace(/^\//, ""));
  const isStandalone = isAdmin || location.pathname === "/europe" || isAdLanding;

  return (
    <>
      {!isStandalone && <AutoRegionBanner />}
      {!isStandalone && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/torwarthandschuhe-damen" element={<TorwarthandschuheDamen />} />
          <Route path="/europe" element={<Europe />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<Landing />} />
          <Route path="/panther-pro" element={<AdLandingPage />} />
          <Route path="/mamba-pro" element={<AdLandingPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </main>
      {!isStandalone && <Footer />}
      {(!isAdmin && location.pathname !== "/europe") && <CartDrawer />}
      {!isStandalone && <AutoDiscountWelcome />}
    </>
  );
};

function App() {
  return (
    <div className="App bg-black text-white min-h-screen">
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Shell />
            </BrowserRouter>
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{
                style: {
                  background: "#0A0A0A",
                  border: "1px solid rgba(255,255,255,0.15)",
                  color: "#fff",
                  borderRadius: 0,
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
